import { render, staticRenderFns } from "./rewardThemePackEdit.vue?vue&type=template&id=72246b96&scoped=true&"
import script from "./rewardThemePackEdit.vue?vue&type=script&lang=js&"
export * from "./rewardThemePackEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72246b96",
  null
  
)

export default component.exports